import type { Doc } from 'yjs';

import { getTimestamp } from '../../../lib/helpers';

import { CONTENT_TYPE_DEFINITION_UPDATED_AT_KEY } from '../../useWebsocket/useWebsocketForForm';

/**
 * Writes the CTD's updatedAt into the shared yjs map, but only if it's newer
 * than what's already there — keeps all collaborators on the same schema version.
 * No-op when prerequisites aren't met.
 */
export const syncContentTypeUpdatedAt = (
  yjsDocument: Doc,
  contentTypeUpdatedAt?: string | null,
) => {
  const timestamp = getTimestamp(contentTypeUpdatedAt);
  if (timestamp === null || !contentTypeUpdatedAt) return;

  const formStateMap = yjsDocument.getMap('formState');
  const currentUpdatedAt = formStateMap.get(
    CONTENT_TYPE_DEFINITION_UPDATED_AT_KEY,
  );
  const currentTimestamp =
    typeof currentUpdatedAt === 'string'
      ? getTimestamp(currentUpdatedAt)
      : null;

  if (currentTimestamp !== null && currentTimestamp >= timestamp) return;

  formStateMap.set(
    CONTENT_TYPE_DEFINITION_UPDATED_AT_KEY,
    contentTypeUpdatedAt,
  );
};
